import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { StorageService } from '../../shared/storage.service';
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css']
})
export class OTPVerificationComponent implements OnInit {
  otpForm: FormGroup;
  validForm = true;
  submitted = false;
  errorMessage: string = '';
  userData: any;
  userId: string = '';
  isForgotPassword: boolean = false;
  // showResendButton: boolean = false;
  isResending: boolean = true;
  remainingSeconds: number = 60;
  resendTimeout: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public loginLayoutService: LoginLayoutService,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    // Fetch user data from local storage
    this.userData = JSON.parse(this.storageService.getValue('userData'));
    // console.log(this.userData);
    // console.log(this.userData.id);
this.validForm = true;
    this.route.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.isForgotPassword = params['isForgotPassword'];
    });

    // Initialize OTP form
    this.otpForm = this.fb.group({
      otp1: ['', [Validators.required, Validators.minLength(1)]],
      otp2: ['', [Validators.required, Validators.minLength(1)]],
      otp3: ['', [Validators.required, Validators.minLength(1)]],
      otp4: ['', [Validators.required, Validators.minLength(1)]]
    });

    this.startCountdown();
  }

  // Getter for form controls
  get f() {
    return this.otpForm.controls;
  }

  // Combine OTP digits into one string
  get otpCode(): string {
    return `${this.f.otp1.value}${this.f.otp2.value}${this.f.otp3.value}${this.f.otp4.value}`;
  }

  // Handle OTP form submission
  onSubmit() {
    this.submitted = true;

    // Stop if the form is invalid
    if (this.otpForm.invalid) {
      // console.log("invalid form")
      return;
    }
    this.validForm = false;
    const otpData = {
      userId: this.isForgotPassword ? this.userId : this.userData.id,
      otpCode: this.otpCode
    };


    if (!this.isForgotPassword) {

      this.loginLayoutService.verifyOtp(otpData).subscribe((Response: any) => {
        if (Response.code == 1) {
          // OTP verification successful
          this.commonService.notifier.notify('success', 'OTP verified successfully.');
          this.router.navigate(['login']);
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      }, (error) => {
        // console.log(error);
        this.commonService.notifier.notify('error', 'Failed to verify OTP. Please try again.');
      });
    } else if (this.isForgotPassword) {
    
      this.loginLayoutService.forgotverifyOtp(otpData).subscribe(
        (Response: any) => {
          if (Response.code === 1) {
            // Navigate to the Reset Password page
            this.router.navigate(['reset-password'], { queryParams: { userId: this.userId } });
          } else {
            this.commonService.notifier.notify('error', Response.message);
          }
        },
        (error) => {
          // console.log('API Error:', error); // Log error to the console
          this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
        }
      );
    } else {
      // console.log("Wrong Params or Situation");
    }

  }

  onResendOtp() {
    this.isResending = true;
    this.remainingSeconds = 60;

    if (!this.isForgotPassword) {
      const otpData = {
        userId: this.userData.id,
      };

      // Call your service to resend OTP
      this.loginLayoutService.resendOtp(otpData).subscribe((Response: any) => {
        if (Response.code == 1) {
          this.commonService.notifier.notify('success', 'OTP resent to your email.');
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
        error => {
          // console.log('API Error:', error);
          this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
        }
      );
    } else if (this.isForgotPassword){
      const otpData = {
        userId: this.userId,
      };

      // Call your service to resend OTP
      this.loginLayoutService.forgotResendOtp(otpData).subscribe((Response: any) => {
        if (Response.code == 1) {
          this.commonService.notifier.notify('success', 'OTP resent to your email.');
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
        error => {
          // console.log('API Error:', error);
          this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
        }
      );
    } else {
      // console.log("Wrong API calling");
    }

    // Start countdown for resend button
    this.startCountdown();
  }

  startCountdown() {
    this.resendTimeout = setInterval(() => {
      this.remainingSeconds--;

      if (this.remainingSeconds <= 0) {
        clearInterval(this.resendTimeout);
        this.isResending = false;
      }
    }, 1000);
  }

  // Optional: Auto-focus to the next OTP input
  onKeyUpEvent(event: any, index: number) {
    const inputs = document.getElementsByClassName('otp-field') as HTMLCollectionOf<HTMLInputElement>;
    if (event.target.value.length === 1 && index < inputs.length - 1) {
      inputs[index + 1].focus();
    }
    if (event.key === 'Backspace' && index > 0 && event.target.value === '') {
      inputs[index - 1].focus();
      inputs[index - 1].value = '';  
    }
    
    if (this.otpForm.valid) {
      this.validForm = false
    } else {
      this.validForm = true;
    }
  }
  

}
